import { EmailIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";

const PageTitle = ({ children, Style = "", contactEmail }) => {
  return (
    <h2
      className={` text-4xl font-medium text-center ${Style}`}
    >
      {children}<br/>
      {contactEmail && <Flex alignContent="center" justifyContent="center">
        <EmailIcon/>
        <h5 className="text-2xl font-medium ml-2">{contactEmail}</h5>
      </Flex>}
    </h2>
  );
};

export default PageTitle;
